<template>
  <div class="container">
    <Header />
    <Main />
    <Notify />
  </div>
</template>

<script>
import Header from './HomeHeader.vue'
import Main from './HomeFunction.vue'
import Notify from './HomeNotify.vue'

export default {
  components: {
    Header,
    Main,
    Notify
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  box-sizing: border-box;
  padding: 0 20px;
  padding-bottom: 20px;
}
</style>
